import CaseActivity from "@/features/legal/components/CaseActivity";
import CaseDetails from "@/features/legal/components/CaseDetails";
import CaseHeader from "@/features/legal/components/CaseHeader";
import Deadline from "@/features/legal/components/Deadline";
import InternalNotes from "@/features/legal/components/InternalNotes";
import DmfLegalService from "@/features/legal/components/DmfLegalService";
import { Transition, TransitionChild } from "@headlessui/react";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { useLegalCaseQuery } from "@/hooks/useLegal";

export const Route = createFileRoute("/_protected/_legal/legal/$id/")({
  head: ({ params }) => ({
    meta: [{ title: `Legal · ${params.id}` }],
  }),
  component: LegalCase,
});

function LegalCase() {
  const { id } = useParams({ from: "/_protected/_legal/legal/$id/" });
  const { data: taxCase } = useLegalCaseQuery(id);

  return (
    <Transition appear show as="div" className="transition duration-1000 data-[closed]:opacity-0">
      <TransitionChild>
        <div className="transition duration-500 data-[closed]:translate-y-24">
          <CaseHeader id={id} taxCase={taxCase} />

          <div className="md:p-6 p-4 relative">
            <div className="grid grid-cols-1 2xl:grid-cols-[minmax(300px,1fr)_minmax(0,800px)_minmax(350px,1fr)] gap-6">
              <div className="space-y-5">
                <CaseDetails taxCase={taxCase} />
                <InternalNotes id={id} taxCase={taxCase} />
              </div>

              <div className="space-y-5">
                <CaseActivity id={id} taxCase={taxCase} />
              </div>

              <div className="space-y-5">
                <Deadline taxCase={taxCase} />
                <DmfLegalService id={id} taxCase={taxCase} />
              </div>
            </div>
          </div>
        </div>
      </TransitionChild>
    </Transition>
  );
}
